import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getMyCurrentProgresses,
  addSessionEvent,
  getMyContentProgress,
  getMyContentProgresses,
  markcontentAsCompleted,
  getMyCurrentStartedProgresses,
  getMyCurrentCompletedProgresses,
  getMyCurrentFollowedProgresses,
  getContinueListeningProgresses,
} from './thunks';
import { SessionsState } from './types';

export const name = 'sessions';

const initialState: SessionsState = {
  myContentProgresses: {
    data: {},
    status: 'idle',
  },
  myContentStartedProgresses: {
    data: {},
    status: 'idle',
  },
  myContentCompletedProgresses: {
    data: {},
    status: 'idle',
  },
  myContentFollowedProgresses: {
    data: {},
    status: 'idle',
  },
  continueListeningProgresses: {
    data: {},
    status: 'idle',
  },
  selectedContentProgress: undefined,
  selectedContentProgresses: [],
  selectedContentProgressStatus: 'idle',
  selectedContentProgressesStatus: 'idle',
  updateProgress: false,
};

export const getMyCurrentProgressesAsync = createAsyncThunk(
  name + '/getMyCurrentProgresses',
  getMyCurrentProgresses
);

export const getMyCurrentStartedProgressesAsync = createAsyncThunk(
  name + '/getMyCurrentStartedProgresses',
  getMyCurrentStartedProgresses
);

export const getMyCurrentCompletedProgressesAsync = createAsyncThunk(
  name + '/getMyCurrentCompletedProgresses',
  getMyCurrentCompletedProgresses
);

export const getMyCurrentFollowedProgressesAsync = createAsyncThunk(
  name + '/getMyCurrentFollowedProgresses',
  getMyCurrentFollowedProgresses
);

export const addSessionEventAsync = createAsyncThunk(
  name + '/addSessionEvent',
  addSessionEvent
);

export const getMyContentProgressAsync = createAsyncThunk(
  name + '/getMyContentProgress',
  getMyContentProgress
);

export const getMyContentProgressesAsync = createAsyncThunk(
  name + '/getMyContentProgresses',
  getMyContentProgresses
);
export const markcontentAsCompletedAsync = createAsyncThunk(
  name + '/markcontentAsCompleted',
  markcontentAsCompleted
);

export const getContinueListeningProgressesAsync = createAsyncThunk(
  name + '/getContinueListeningProgresses',
  getContinueListeningProgresses
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearDetails: (state) => {
      state.myContentProgresses = initialState.myContentProgresses;
    },
    setUpdateProgress: (state, action) => {
      state.updateProgress = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMyCurrentProgressesAsync.pending, (state) => {
        state.myContentProgresses.status = 'loading';
      })
      .addCase(getMyCurrentProgressesAsync.fulfilled, (state, action) => {
        state.myContentProgresses.status = 'idle';
        state.myContentProgresses.data = {
          ...state.myContentProgresses.data,
          ...action.payload,
        };
      })
      .addCase(getMyCurrentProgressesAsync.rejected, (state) => {
        state.myContentProgresses.status = 'failed';
      })
      .addCase(getMyCurrentStartedProgressesAsync.pending, (state) => {
        state.myContentStartedProgresses.status = 'loading';
      })
      .addCase(
        getMyCurrentStartedProgressesAsync.fulfilled,
        (state, action) => {
          state.myContentStartedProgresses.status = 'idle';
          state.myContentStartedProgresses.data = {
            ...state.myContentProgresses.data,
            ...action.payload,
          };
        }
      )
      .addCase(getMyCurrentStartedProgressesAsync.rejected, (state) => {
        state.myContentStartedProgresses.status = 'failed';
      })
      .addCase(getMyCurrentCompletedProgressesAsync.pending, (state) => {
        state.myContentCompletedProgresses.status = 'loading';
      })
      .addCase(
        getMyCurrentCompletedProgressesAsync.fulfilled,
        (state, action) => {
          state.myContentCompletedProgresses.status = 'idle';
          state.myContentCompletedProgresses.data = {
            ...state.myContentProgresses.data,
            ...action.payload,
          };
        }
      )
      .addCase(getMyCurrentCompletedProgressesAsync.rejected, (state) => {
        state.myContentCompletedProgresses.status = 'failed';
      })
      .addCase(getMyCurrentFollowedProgressesAsync.pending, (state) => {
        state.myContentFollowedProgresses.status = 'loading';
      })
      .addCase(
        getMyCurrentFollowedProgressesAsync.fulfilled,
        (state, action) => {
          state.myContentFollowedProgresses.status = 'idle';
          state.myContentFollowedProgresses.data = {
            ...state.myContentProgresses.data,
            ...action.payload,
          };
        }
      )
      .addCase(getMyCurrentFollowedProgressesAsync.rejected, (state) => {
        state.myContentFollowedProgresses.status = 'failed';
      })
      .addCase(getMyContentProgressAsync.pending, (state) => {
        state.selectedContentProgressStatus = 'loading';
      })
      .addCase(getMyContentProgressAsync.fulfilled, (state, action) => {
        state.selectedContentProgressStatus = 'idle';
        state.selectedContentProgress = action.payload;
      })
      .addCase(getMyContentProgressAsync.rejected, (state) => {
        state.selectedContentProgressStatus = 'failed';
      })
      .addCase(getMyContentProgressesAsync.pending, (state) => {
        state.selectedContentProgressesStatus = 'loading';
      })
      .addCase(getMyContentProgressesAsync.fulfilled, (state, action) => {
        state.selectedContentProgressesStatus = 'idle';
        state.selectedContentProgresses = action.payload;
      })
      .addCase(getMyContentProgressesAsync.rejected, (state) => {
        state.selectedContentProgressesStatus = 'failed';
      })
      .addCase(getContinueListeningProgressesAsync.pending, (state) => {
        state.continueListeningProgresses.status = 'loading';
      })
      .addCase(
        getContinueListeningProgressesAsync.fulfilled,
        (state, action) => {
          state.continueListeningProgresses.status = 'idle';
          state.continueListeningProgresses.data = {
            ...state.continueListeningProgresses.data,
            ...action.payload,
          };
        }
      )
      .addCase(getContinueListeningProgressesAsync.rejected, (state) => {
        state.continueListeningProgresses.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
